<template>
  <div class="c-moniadd g-container">
    <div class="module-content" ref="container">
      <moduler name="targetingadd" title="新增定向包">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">媒体</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="targeting.mediaId" type="button" @on-change="changeMedia">
              <Radio :label="16" disabled>腾讯</Radio>
              <Radio :label="32" disabled>磁力引擎</Radio>
              <Radio :label="6" disabled>超级汇川</Radio>
              <Radio :label="45" disabled>百度信息流</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">定向包名称</span>
          </Col>
          <Col span="12">
            <input-len v-model="targeting.targetingName" placeholder="最大30个字符，1个中文等于2个字符" :max="30" width="352" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">描述</span>
          </Col>
          <Col span="12">
            <textarea-len v-model="targeting.targetingDesc" placeholder="最大300个字符，1个中文等于2个字符" :max="300" width="352" />
          </Col>
        </Row>
        <template v-if="!editState || show">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <Poptip
                trigger="hover"
                placement="top-start"
                width="410"
                word-wrap
                content="接入您的应用或网站的数据, 选定或排除特定的用户。您可以在工具箱-头条DMP中管理人群包"
              >
                <Icon type="md-help-circle" size="18" color="#e3e3e3" />
              </Poptip>
              <span class="item-field">人群包</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.retargeting_type" type="button" @on-change="changeRetarget">
                <Radio label="NONE">不限</Radio>
                <Radio label="RETARGETING_INCLUDE">定向或排除人群</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.retargeting_type === 'RETARGETING_INCLUDE'">
            <Col span="3">&nbsp;</Col>
            <Col span="18">
              <auto-complete
                :data="accountData"
                v-model="targeting.accountIds"
                placeholder="请选择账号"
                @on-select="handleAccount"
                style="width: 280px; margin-bottom: 32px"
              />
              <div class="c-retarget-loading" v-if="asying"><Spin size="large" fix></Spin></div>
              <retarget v-else title="选定人群" :data="retargetData" @on-clear="clearRetarget" @on-delete="delRetarget" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">地域</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.district" type="button" @on-change="radioChange('cityData')">
                <Radio label="NONE">不限</Radio>
                <Radio label="REGION">按省市</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-show="plan.district === 'REGION'">
            <Col span="3">&nbsp;</Col>
            <Col span="14">
              <selecter
                v-model="mult_city"
                :data="data.cityData"
                :title="['省份', '城市']"
                @on-select="selectAll"
                @on-delete="delTag"
                @on-clear="clearTag"
              />
              <RadioGroup v-model="plan.location_type" style="margin-top: 32px">
                <Radio label="HOME">居住在该地区的用户</Radio>
                <Radio label="TRAVEL">到该地区旅行的用户</Radio>
                <Radio label="ALL">该地区内的所有用户</Radio>
                <Radio label="CURRENT">正在该地区的用户</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">性别</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.gender" type="button">
                <Radio label="NONE">不限</Radio>
                <Radio label="GENDER_MALE">男</Radio>
                <Radio label="GENDER_FEMALE">女</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">年龄</span>
            </Col>
            <Col span="18">
              <Mixcheck v-model="plan.age">
                <radio-item label="NONE">不限</radio-item>
                <check-item label="AGE_BELOW_18">小于18岁</check-item>
                <check-item label="AGE_BETWEEN_18_23">18-23岁</check-item>
                <check-item label="AGE_BETWEEN_24_30">24-30岁</check-item>
                <check-item label="AGE_BETWEEN_31_40">31-40岁</check-item>
                <check-item label="AGE_BETWEEN_41_49">41-49岁</check-item>
                <check-item label="AGE_ABOVE_50">大于等于50岁</check-item>
              </Mixcheck>
            </Col>
          </Row>

          <!-- 新版 -->
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">行为兴趣定向</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.interest_action_mode" type="button" @on-change="resetInterestAction">
                <Radio label="UNLIMITED">不限</Radio>
                <Radio label="RECOMMEND">系统推荐</Radio>
                <Radio label="CUSTOM">自定义</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="plan.interest_action_mode === 'CUSTOM'">
            <Col span="3" class="col-item">
              <span class="item-field">行为</span>
            </Col>
            <Col span="15">
              <!-- 新版 -->
              <action-interest
                v-model="plan.action_tags"
                :action-scene="plan.action_scene"
                :action-days="plan.action_days"
                :accounts="[{ id: toutiaoManageId }]"
                :max="350"
                action
                @on-days="setDays"
                @on-scene="setScene"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.interest_action_mode === 'CUSTOM'">
            <Col span="3" class="col-item">
              <span class="item-field">兴趣</span>
            </Col>
            <Col span="15">
              <!-- 新版 -->
              <action-interest v-model="plan.word_tags" :max="350" :accounts="[{ id: toutiaoManageId }]" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-show="false">
            <Col span="3" class="col-item">
              <span class="item-field">兴趣定向</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.tags" type="button" @on-change="radioChange('tagsData')">
                <Radio label="NONE">不限</Radio>
                <Radio label="REFEREE">系统推荐</Radio>
                <Radio label="CUSTOM">自定义</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-show="plan.tags === 'CUSTOM'">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <selecter
                v-model="mult_tags"
                :data="data.tagsData"
                :title="['兴趣分类']"
                @on-select="selectAll"
                @on-delete="delTag"
                @on-clear="clearTag"
              />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">穿山甲媒体定向</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.superior_popularity_type" type="button">
                <Radio label="NONE">不限</Radio>
                <!-- <Radio label="APP">应用软件精选流量包</Radio> -->
                <Radio label="GAME">游戏优质媒体</Radio>
                <Radio label="CUSTOM">自定义</Radio>
                <!-- <Radio label="INCLUDE">定向流量包</Radio>
                <Radio label="EXCLUDE">排除流量包</Radio> -->
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.superior_popularity_type === 'CUSTOM'">
            <Col span="3">&nbsp;</Col>
            <Col span="18">
              <auto-complete
                :data="accountData"
                v-model="targeting.accountIds"
                placeholder="请选择账号"
                @on-select="handleAccount"
                style="width: 280px; margin-bottom: 32px"
              />
              <div class="c-retarget-loading" v-if="asying"><Spin size="large" fix></Spin></div>
              <metarget
                v-else
                title="媒体包"
                :data="metargetData"
                @on-select="handleSelect"
                @on-clear="clearRetarget"
                @on-delete="delRetarget"
              />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">平台</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.platform" type="button" @on-change="resetPlat">
                <Radio label="NONE">不限</Radio>
                <Radio label="ANDROID">Android</Radio>
                <Radio label="IOS">iOS</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="isAndroid">
            <Col span="3" class="col-item">
              <span class="item-field">安卓版本</span>
            </Col>
            <Col span="12">
              <version v-model="plan.android_osv" :data="data.androidVersion" title="安卓版本" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="isiOS">
            <Col span="3" class="col-item">
              <span class="item-field">iOS版本</span>
            </Col>
            <Col span="12">
              <version v-model="plan.ios_osv" :data="data.iOSVersion" title="iOS版本" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">过滤已转化</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.hide_if_converted" type="button">
                <Radio label="AD">计划</Radio>
                <Radio label="CAMPAIGN">计划组</Radio>
                <Radio label="ADVERTISER">计划账户</Radio>
                <Radio label="NO_EXCLUDE">不过滤</Radio>
                <Radio label="APP">APP</Radio>
                <Radio label="CUSTOMER">公司账户</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">设备类型</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.device" type="button" @on-change="changeDeviceType">
                <Radio label="NONE">不限</Radio>
                <Radio label="DEVICE">设备类型</Radio>
              </RadioGroup>
              <span style="color: #ff4400; margin-left: 12px; display: inline-block" v-if="plan.device === 'DEVICE'"
                >提示：非白名单账户会报错，慎重选择！</span
              >
            </Col>
          </Row>
          <Row v-if="plan.device === 'DEVICE'" class="row-item" :gutter="12">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <CheckboxGroup v-model="plan.device_type">
                <Checkbox label="MOBILE">智能手机</Checkbox>
                <Checkbox label="PAD">平板</Checkbox>
              </CheckboxGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">智能放量</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.auto_extend_enabled" type="button" @on-change="radioChange('autotendData')">
                <Radio :label="0">不启用</Radio>
                <Radio :label="1">启用</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.auto_extend_enabled === 1">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <selecter
                v-model="mult_autotend"
                :data="data.autotendData"
                :title="['可放开定向']"
                @on-select="selectAll"
                @on-delete="delTag"
                @on-clear="clearTag"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">网络</span>
            </Col>
            <Col span="12">
              <Mixcheck v-model="plan.ac">
                <radio-item label="NONE">不限</radio-item>
                <check-item label="WIFI">WIFI</check-item>
                <check-item label="2G">2G</check-item>
                <check-item label="3G">3G</check-item>
                <check-item label="4G">4G</check-item>
                <check-item label="5G">5G</check-item>
              </Mixcheck>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">运营商</span>
            </Col>
            <Col span="12">
              <Mixcheck v-model="plan.carrier">
                <radio-item label="NONE">不限</radio-item>
                <check-item label="MOBILE">移动</check-item>
                <check-item label="UNICOM">联通</check-item>
                <check-item label="TELCOM">电信</check-item>
              </Mixcheck>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="新用户使用头条的时间">
                <Icon type="md-help-circle" size="18" color="#e3e3e3" />
              </Poptip>
              <span class="item-field">新用户</span>
            </Col>
            <Col span="12">
              <Mixcheck v-model="plan.activate_type">
                <radio-item label="NONE">不限</radio-item>
                <check-item label="WITH_IN_A_MONTH">一个月以内</check-item>
                <check-item label="ONE_MONTH_2_THREE_MONTH">一个月到三个月</check-item>
                <check-item label="THREE_MONTH_EAILIER">三个月或更早</check-item>
              </Mixcheck>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-show="isAndroid">
            <Col span="3" class="col-item">
              <span class="item-field">APP行为</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.app_behavior_target" type="button" @on-change="radioChange('gategoryData')">
                <Radio label="NONE">不限</Radio>
                <Radio label="CATEGORY">按分类</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-show="isAndroid && plan.app_behavior_target === 'CATEGORY'">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <selecter
                v-model="mult_gategory"
                :data="data.gategoryData"
                :title="['按分类']"
                @on-select="selectAll"
                @on-delete="delTag"
                @on-clear="clearTag"
              />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-show="isAndroid">
            <Col span="3" class="col-item">
              <span class="item-field">手机品牌</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.brand" type="button" @on-change="radioChange('brandData')">
                <Radio label="NONE">不限</Radio>
                <Radio label="BRAND">按手机品牌</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-show="isAndroid && plan.brand === 'BRAND'">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <selecter
                v-model="mult_brand"
                :data="data.brandData"
                :title="['手机品牌']"
                @on-select="selectAll"
                @on-delete="delTag"
                @on-clear="clearTag"
              />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">手机价格</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.price" type="button" @on-change="changePrice">
                <Radio label="NONE">不限</Radio>
                <Radio label="CUSTOM">自定义</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="plan.price === 'CUSTOM'">
            <Col span="3" class="col-item">
              <span>&nbsp;</span>
            </Col>
            <Col span="10">
              <range-price v-model="plan.launch_price" @on-short="changePriceValue" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-show="false">
            <Col span="3" class="col-item">
              <Poptip
                trigger="hover"
                placement="top-start"
                width="410"
                word-wrap
                content="只针对投放在详情页位置的计划生效, 不支持人群预估"
              >
                <Icon type="md-help-circle" size="18" color="#e3e3e3" />
              </Poptip>
              <span class="item-field">文章分类</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.article" type="button" @on-change="radioChange('articleData')">
                <Radio label="NONE">不限</Radio>
                <Radio label="ARTICLE">文章分类</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-show="false && plan.article === 'ARTICLE'">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <selecter
                v-model="mult_article"
                :data="data.articleData"
                :title="['文章分类']"
                @on-select="selectAll"
                @on-delete="delTag"
                @on-clear="clearTag"
              />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">直播定向</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-switch v-model="islive" :true-value="1" :false-value="0" />
            </Col>
          </Row>
          <template v-if="islive">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">抖音达人</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.aweme_talents" type="button" @on-change="resetAwemeAction">
                  <Radio label="NONE">不限</Radio>
                  <Radio label="CUSTOM">自定义</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-show="plan.aweme_talents === 'CUSTOM'">
              <Col span="3">&nbsp;</Col>
              <Col span="12">
                <aweme-action
                  v-model="plan.fan_tags"
                  :behaviors="plan.aweme_fan_behaviors"
                  :timescope="plan.aweme_fan_time_scope"
                  :max="30"
                  @on-days="setTimes"
                  @on-scene="setBehavior"
                />
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">过滤高活跃用户</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.filter_aweme_abnormal_active" type="button">
                  <Radio :label="0">不过滤</Radio>
                  <Radio :label="1">过滤</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">过滤自己粉丝</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.filter_own_aweme_fans" type="button">
                  <Radio :label="0">不过滤</Radio>
                  <Radio :label="1">过滤</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">过滤高关注数用户</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.filter_aweme_fans_count" type="button">
                  <Radio :label="0">不过滤</Radio>
                  <Radio :label="1000"> >1000 </Radio>
                  <Radio :label="500"> >500 </Radio>
                  <Radio :label="200"> >200 </Radio>
                </RadioGroup>
              </Col>
            </Row>
          </template>
        </template>
      </moduler>
    </div>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="save">
            <span v-if="!loading">更新</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import validMixin from './mixins/valid-mixin'
import { adAccount } from '@/api/common.model'
import { getCustomAudience, getFlowPackage } from '@/api/toutiao.model'
import { addTargeting, updateTargeting, getTargetingDataById, queryManageIdByMedia } from '@/api/manage.model'
import { timeout, isArray, isEmpty, findCheck, getNameOfData, getKeyOfData, clearTagOfData } from '@/common/js/utils'

import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import Selecter from '@/components/select/selecter.vue'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import InputLen from '@/components/input/input-len.vue'
import TextareaLen from '@/components/input/textarea-len.vue'
import Version from '@/components/version/'
import RangePrice from '@/components/range-price/range-price'
import Retarget from '@/components/retarget/retarget.vue'
import Metarget from '@/components/retarget/metarget.vue'
import AutoComplete from '@/components/autocomplete/autocomplete'
import ActionInterest from '@/views/create/toutiao_local/components/actioninterest/'
import AwemeAction from '@/views/create/toutiao_local/components/awemeaction/'

import articleData from '@/data/toutiao/article_categroy'
import brandData from '@/data/toutiao/brand_categroy'
import cityData from '@/data/toutiao/city_province'
import tagsData from '@/data/toutiao/ad_tag'
import gategoryData from '@/data/toutiao/app_categroy'
import autotendData from '@/data/toutiao/auto_extend_targets'
import androidVersion from '@/data/toutiao/android_version'
import iOSVersion from '@/data/toutiao/ios_version'

export default {
  name: 'targetingdata',
  mixins: [validMixin],
  components: {
    Moduler,
    ErrorPop,
    Selecter,
    Mixcheck,
    CheckItem,
    RadioItem,
    InputLen,
    TextareaLen,
    Version,
    RangePrice,
    Retarget,
    Metarget,
    AutoComplete,
    ActionInterest,
    AwemeAction
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    isAndroid() {
      return this.plan.platform === 'ANDROID'
    },
    isiOS() {
      return this.plan.platform === 'IOS'
    },
    mult_city() {
      return findCheck(this.data.cityData)
    },
    mult_tags() {
      return findCheck(this.data.tagsData)
    },
    mult_gategory() {
      return findCheck(this.data.gategoryData)
    },
    mult_brand() {
      return findCheck(this.data.brandData)
    },
    mult_article() {
      return findCheck(this.data.articleData)
    },
    mult_autotend() {
      return findCheck(this.data.autotendData)
    },
    formatMarks() {
      let price = ''
      const [min, max] = this.plan.launch_price
      if (min === 0 && max === 11000) price = '不限'
      else if (min === 0) price = `${max}元以内`
      else if (max === 11000) price = `${min}元以上`
      else price = `${min}元-${max}元`
      return price
    },
    marks() {
      return {
        0: '0',
        500: '',
        1000: '',
        1500: '',
        2000: '2000元',
        2500: '',
        3000: '',
        3500: '',
        4000: '',
        5000: '5000元',
        6000: '',
        7000: '',
        8000: '',
        9000: '',
        10000: '1万元',
        11000: ''
      }
    },
    smart_volume() {
      return {
        REGION: this.plan.district === 'NONE',
        GENDER: this.plan.gender === 'NONE',
        AGE: this.plan.age === 'NONE',
        CUSTOM_AUDIENCE: this.plan.retargeting_type === 'NONE',
        INTEREST_ACTION: this.plan.interest_action_mode === 'UNLIMITED',
        init: this.init_flag // 用于第一次未产生变化初始化禁用状态
      }
    }
  },
  watch: {
    mult_city(nVal) {
      if (nVal && nVal.length) {
        this.plan.city = nVal.map((ret) => ret.id)
        !this.plan.location_type && (this.plan.location_type = 'HOME')
      } else {
        this.plan.city = []
        this.plan.location_type = undefined
      }
    },
    mult_tags(nVal) {
      if (nVal && nVal.length) {
        this.plan.ad_tag = nVal.map((ret) => ret.id)
      } else {
        this.plan.ad_tag = []
      }
    },
    mult_gategory(nVal) {
      if (nVal && nVal.length) {
        this.plan.app_category = nVal.map((ret) => ret.id)
      } else {
        this.plan.app_category = []
      }
    },
    mult_brand(nVal) {
      if (nVal && nVal.length) {
        this.plan.device_brand = nVal.map((ret) => ret.key)
      } else {
        this.plan.device_brand = []
      }
    },
    mult_article(nVal) {
      if (nVal && nVal.length) {
        this.plan.article_category = nVal.map((ret) => ret.key)
      } else {
        this.plan.article_category = []
      }
    },
    mult_autotend(nVal) {
      if (nVal && nVal.length) {
        this.plan.auto_extend_targets = nVal.map((ret) => ret.key)
      } else {
        this.plan.auto_extend_targets = []
      }
    },
    'plan.action_tags'(nVal) {
      if (isArray(nVal)) {
        this.plan.action_categories = nVal.filter((ret) => ret.type.toLowerCase() === 'category').map((met) => parseInt(met.id))
        this.plan.action_words = nVal.filter((ret) => ret.type.toLowerCase() === 'keyword').map((met) => parseInt(met.id))
      }
    },
    'plan.word_tags'(nVal) {
      if (isArray(nVal)) {
        this.plan.interest_categories = nVal.filter((ret) => ret.type.toLowerCase() === 'category').map((met) => parseInt(met.id))
        this.plan.interest_words = nVal.filter((ret) => ret.type.toLowerCase() === 'keyword').map((met) => parseInt(met.id))
      }
    },
    'plan.fan_tags'(nVal) {
      if (isArray(nVal)) {
        const categories = nVal.filter((ret) => ret.type.toLowerCase() === 'category').map((met) => parseInt(met.id))
        const words = nVal.filter((ret) => ret.type.toLowerCase() === 'keyword').map((met) => parseInt(met.id))
        this.$set(this.plan, 'aweme_fan_categories', categories)
        this.$set(this.plan, 'aweme_fan_accounts', words)
      }
    },
    'plan.launch_price': {
      handler(nVal) {
        const [min, max] = nVal
        if (min === max) {
          this.$Message.warning({
            content: '请输入正确的价格区间！首尾价格不能相等',
            duration: 3
          })
        }
      },
      deep: true
    },
    smart_volume: {
      handler(val) {
        this.data.autotendData.forEach((ret) => {
          if (val[ret.key]) {
            // 禁用 取消勾选
            this.$set(ret, 'check', false)
          }
          this.$set(ret, 'disabled', val[ret.key]) // 禁用
        })
      },
      deep: true
    }
  },
  methods: {
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      data.forEach((ret) => {
        if (ret.children && ret.children.length) {
          ret.children.map((rec) => {
            this.$set(rec, 'check', check)
            return rec
          })
        } else this.$set(ret, 'check', check)
      })
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    // 清空行为兴趣定向
    resetInterestAction() {
      this.plan.action_scene = []
      this.plan.action_days = 30
      this.plan.action_tags = []
      this.plan.word_tags = []
      this.plan.action_categories = []
      this.plan.action_words = []
      this.plan.interest_categories = []
      this.plan.interest_words = []
    },
    resetAwemeAction() {
      this.$set(this.plan, 'fan_tags', [])
      this.$set(this.plan, 'aweme_fan_time_scope', 'FIFTEEN_DAYS')
      this.$set(this.plan, 'aweme_fan_behaviors', ['FOLLOWED_USER'])
    },
    // 手机价格
    changePrice(val) {
      if (val === 'NONE') this.plan.launch_price = [0, 11000]
    },
    changeDeviceType(val) {
      if (val === 'NONE') this.plan.device_type = []
    },
    changePriceValue(val) {
      this.$set(this.plan, 'launch_price', val)
    },
    setDays(val) {
      this.$set(this.plan, 'action_days', val)
    },
    setScene(val) {
      this.$set(this.plan, 'action_scene', val)
    },
    setBehavior(val) {
      this.$set(this.plan, 'aweme_fan_behaviors', val)
    },
    setTimes(val) {
      this.$set(this.plan, 'aweme_fan_time_scope', val)
    },
    radioChange(key) {
      clearTagOfData(this.data[key], this)
    },
    resetPlat() {
      this.plan.android_osv = '0.0'
      this.plan.ios_osv = '0.0'
      this.plan.app_behavior_target = 'NONE'
      this.plan.brand = 'NONE'
      this.radioChange('gategoryData')
      this.radioChange('brandData')
    },
    getData() {
      // 加载动画
      getTargetingDataById({
        targetingId: this.targeting.targetingId
      })
        .then((data) => {
          this.show = true
          this.$Spin.hide()
          if (data) {
            const { targetingId, targetingName, targetingDesc, targetingParamJson, accountIds } = data
            this.targeting = Object.assign({}, this.targeting, {
              targetingId,
              targetingName,
              targetingDesc,
              accountIds: Number(accountIds)
            })
            if (targetingParamJson) {
              if (isArray(targetingParamJson.platform)) targetingParamJson.platform = targetingParamJson.platform.pop()
              this.islive = Number(typeof targetingParamJson.filter_aweme_abnormal_active === 'number')
              Object.assign(this.plan, targetingParamJson)
              // 设备类型
              if (isArray(this.plan.device_type) && this.plan.device_type.length) this.plan.device = 'DEVICE'
              else this.plan.device_type = [] // 兼容老数据
              // 多选值得清空与解析
              this.decompile(this.plan.city, 'cityData')
              this.decompile(this.plan.ad_tag, 'tagsData')
              this.decompile(this.plan.app_category, 'gategoryData')
              this.decompileKey(this.plan.article_category, 'articleData')
              this.decompileKey(this.plan.device_brand, 'brandData')
              this.decompileKey(this.plan.auto_extend_targets, 'autotendData')
              Number(accountIds) && this.getRetarget(Number(accountIds))
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.$Message.error(err)
        })
    },
    decompile(Ids, data) {
      if (!isArray(Ids) || !Ids.length) this.radioChange(data)
      else {
        Ids.forEach((ret) => {
          const item = getKeyOfData(this.data[data], 'id', ret)
          this.$set(item, 'check', true)
          if (item.children && item.children.length) {
            item.children.forEach((met) => {
              this.$set(met, 'check', true)
            })
          }
        })
      }
    },
    decompileKey(vals, data) {
      if (!isArray(vals) || !vals.length) this.radioChange(data)
      else {
        vals.forEach((ret) => {
          const item = getKeyOfData(this.data[data], 'key', ret)
          this.$set(item, 'check', true)
        })
      }
    },
    valid() {
      const rules = [
        {
          name: 'targeting/targetingName',
          require: true,
          min: 1,
          max: 30,
          desc: '定向包名称'
        },
        {
          name: 'mult_city',
          require: true,
          relyon: 'plan/district',
          relyvalue: 'CITY',
          min: 1,
          desc: '地域'
        },
        {
          name: 'mult_tags',
          require: true,
          relyon: 'plan/tags',
          relyvalue: 'CUSTOM',
          min: 1,
          desc: '兴趣分类'
        },
        {
          name: 'mult_gategory',
          require: true,
          relyon: 'plan/app_behavior_target',
          relyvalue: 'CATEGORY',
          min: 1,
          desc: 'APP行为'
        },
        {
          name: 'mult_brand',
          require: true,
          relyon: 'plan/brand',
          relyvalue: 'BRAND',
          min: 1,
          desc: '手机品牌'
        },
        {
          name: 'mult_article',
          require: true,
          relyon: 'plan/article',
          relyvalue: 'ARTICLE',
          min: 1,
          desc: '文章分类'
        },
        {
          name: 'mult_autotend',
          require: true,
          relyon: 'plan/auto_extend_enabled',
          relyvalue: 1,
          min: 1,
          desc: '智能放量'
        },
        {
          name: 'plan/device_type',
          require: true,
          relyon: 'plan/device',
          relyvalue: 'DEVICE',
          min: 1,
          desc: '设备类型'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    customValid() {
      const err = []
      // 手机价格不能相同
      if (isArray(this.plan.launch_price) && this.plan.launch_price[0] === this.plan.launch_price[1]) {
        err.push({ feild: '手机价格', msg: '请输入正确的价格区间！首尾价格不能相等' })
      }
      const includes = this.retargetData.filter((ret) => ret.select === 'include')
      const excludes = this.retargetData.filter((ret) => ret.select === 'exclude')
      const media_includes = this.metargetData.filter((ret) => ret.select === 'include')
      const media_excludes = this.metargetData.filter((ret) => ret.select === 'exclude')
      // 人群包
      if (this.plan.retargeting_type === 'RETARGETING_INCLUDE' && !includes.length && !excludes.length) {
        err.push({ feild: '人群包', msg: '请选择人群包，或是切换成不限' })
      }
      // 媒体流量包
      if (this.plan.superior_popularity_type === 'CUSTOM' && !media_includes.length && !media_excludes.length) {
        err.push({ feild: '穿山甲媒体定向', msg: '请选择媒体包，或是切换成不限' })
      }
      // 账号
      if ((includes.length || excludes.length) && isEmpty(this.targeting.accountIds)) {
        err.push({ feild: '人群包', msg: '账号不能为空' })
      }
      // 媒体流量包账号
      if ((media_includes.length || media_excludes.length) && isEmpty(this.targeting.accountIds)) {
        err.push({ feild: '穿山甲媒体定向', msg: '账号不能为空' })
      }
      return err
    },
    save() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const plan = JSON.parse(JSON.stringify(this.plan))
      if (plan.platform !== 'NONE') plan.platform = [plan.platform]
      if (plan.retargeting_type === 'RETARGETING_INCLUDE') {
        plan.includes = this.retargetData.filter((ret) => ret.select === 'include')
        plan.excludes = this.retargetData.filter((ret) => ret.select === 'exclude')
        plan.retargeting_tags_include = this.retargetData.filter((ret) => ret.select === 'include').map((ret) => ret.id)
        plan.retargeting_tags_exclude = this.retargetData.filter((ret) => ret.select === 'exclude').map((ret) => ret.id)
      } else {
        plan.includes = []
        plan.excludes = []
        plan.retargeting_tags_include = []
        plan.retargeting_tags_exclude = []
      }
      if (plan.superior_popularity_type === 'CUSTOM') {
        plan.media_includes = this.metargetData.filter((ret) => ret.select === 'include')
        plan.media_excludes = this.metargetData.filter((ret) => ret.select === 'exclude')
        plan.flow_package = this.metargetData.filter((ret) => ret.select === 'include').map((ret) => ret.id)
        plan.exclude_flow_package = this.metargetData.filter((ret) => ret.select === 'exclude').map((ret) => ret.id)
      } else {
        plan.media_includes = []
        plan.media_excludes = []
        plan.flow_package = []
        plan.exclude_flow_package = []
      }
      if (!this.islive) {
        plan.fan_tags = undefined
        plan.aweme_talents = undefined
        plan.aweme_fan_behaviors = undefined
        plan.aweme_fan_time_scope = undefined
        plan.filter_aweme_abnormal_active = undefined
        plan.filter_own_aweme_fans = undefined
        plan.filter_aweme_fans_count = undefined
        plan.aweme_fan_accounts = undefined
        plan.aweme_fan_categories = undefined
      }
      const params = Object.assign({}, this.targeting, {
        targetingParamJson: plan,
        targetingParam: JSON.stringify(plan),
        accountIds: String(this.targeting.accountIds)
      })

      this.$Spin.show()
      this.loading = true
      updateTargeting(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: '修改成功！2秒后自动跳转'
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    submit() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const plan = JSON.parse(JSON.stringify(this.plan))
      if (plan.platform !== 'NONE') plan.platform = [plan.platform]
      if (plan.retargeting_type === 'RETARGETING_INCLUDE') {
        plan.includes = this.retargetData.filter((ret) => ret.select === 'include')
        plan.excludes = this.retargetData.filter((ret) => ret.select === 'exclude')
        plan.retargeting_tags_include = this.retargetData.filter((ret) => ret.select === 'include').map((ret) => ret.id)
        plan.retargeting_tags_exclude = this.retargetData.filter((ret) => ret.select === 'exclude').map((ret) => ret.id)
      }
      if (plan.superior_popularity_type === 'CUSTOM') {
        plan.media_includes = this.metargetData.filter((ret) => ret.select === 'include')
        plan.media_excludes = this.metargetData.filter((ret) => ret.select === 'exclude')
        plan.flow_package = this.metargetData.filter((ret) => ret.select === 'include').map((ret) => ret.id)
        plan.exclude_flow_package = this.metargetData.filter((ret) => ret.select === 'exclude').map((ret) => ret.id)
      } else {
        plan.media_includes = []
        plan.media_excludes = []
        plan.flow_package = []
        plan.exclude_flow_package = []
      }
      if (!this.islive) {
        plan.fan_tags = undefined
        plan.aweme_talents = undefined
        plan.aweme_fan_behaviors = undefined
        plan.aweme_fan_time_scope = undefined
        plan.filter_aweme_abnormal_active = undefined
        plan.filter_own_aweme_fans = undefined
        plan.filter_aweme_fans_count = undefined
        plan.aweme_fan_accounts = undefined
        plan.aweme_fan_categories = undefined
      }
      const params = Object.assign({}, this.targeting, {
        targetingParamJson: plan,
        targetingParam: JSON.stringify(plan),
        accountIds: String(this.targeting.accountIds)
      })
      this.$Spin.show()
      this.loading = true
      addTargeting(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: '提交成功！2秒后自动跳转'
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    handleAccount(meta) {
      if (meta && meta.id) {
        this.$set(this.targeting, 'accountIds', meta.id)
        this.getRetarget(meta.id)
      } else this.retargetData = []
    },
    async getRetarget(id) {
      this.asying = true
      const param = { account: id }
      const [audiences, flowPackages] = await Promise.all([getCustomAudience(param), getFlowPackage(param)])
      if (audiences && audiences.success && isArray(audiences.models.retData)) {
        this.retargetData = audiences.models.retData.map((r) => {
          const { includes, excludes } = this.plan
          const include = (met) => {
            if (isArray(includes) && includes.map((m) => m.id).includes(met)) return 'include'
            else if (isArray(excludes) && excludes.map((m) => m.id).includes(met)) return 'exclude'
            else return null
          }
          return {
            id: r.custom_audience_id,
            name: r.name,
            source: r.source,
            select: include(r.custom_audience_id)
          }
        })
      } else this.retargetData = []
      if (isArray(flowPackages)) {
        this.metargetData = flowPackages.map((r) => {
          const { media_includes, media_excludes } = this.plan
          const include = (met) => {
            if (isArray(media_includes) && media_includes.map((m) => m.id).includes(met)) return 'include'
            else if (isArray(media_excludes) && media_excludes.map((m) => m.id).includes(met)) return 'exclude'
            else return null
          }
          return {
            id: r.flow_package_id,
            name: r.name,
            type: r.flow_package_type,
            select: include(r.flow_package_id)
          }
        })
      } else this.metargetData = []
      this.asying = false
    },
    // 清空人群包
    clearRetarget({ list }) {
      list.forEach((item) => {
        this.$set(item, 'select', null)
      })
    },
    delRetarget({ list, name }) {
      const index = list.findIndex((ret) => ret.name === name)
      if (index > -1) {
        this.$set(list[index], 'select', null)
      }
    },
    handleSelect({ list, item, type }) {
      const index = list.findIndex((ret) => ret.id === item.id)
      if (index > -1) {
        this.$set(list[index], 'select', type)
      }
    },
    changeRetarget(val) {
      if (val === 'NONE') {
        this.retargetData.forEach((ret) => {
          this.$set(ret, 'select', '')
        })
      }
    },
    preloadData() {
      this.$Spin.show()
      Promise.all([adAccount({ mediaId: this.targeting.mediaId, authFlag: 1 }), queryManageIdByMedia()]).then((data) => {
        if (data && isArray(data)) {
          const [accountData, manageIdData] = data
          if (isArray(accountData)) {
            this.accountData = accountData.map((ret) => {
              return { id: ret.id, name: ret.name }
            })
          }
          if (this.targeting.targetingId) this.getData()
          else {
            this.show = true
            this.$Spin.hide()
          }
          if (manageIdData && isArray(manageIdData)) {
            this.toutiaoManageId = manageIdData.filter((m) => m.mediaId === 10).pop().manageId
          }
        }
      })
    },
    // 切换媒体初始化
    changeMedia() {},
    jump() {
      this.$router.push({ name: 'targetingslist' })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    }
  },
  data() {
    return {
      toutiaoManageId: null,
      targeting: {
        mediaId: 10,
        targetingId: this.$route.query.targetingId,
        accountIds: '',
        targetingName: '',
        targetingDesc: ''
      },
      plan: {
        district: 'NONE', // 地域类型
        location_type: 'HOME', // 受众位置类型
        gender: 'NONE', // 受众性别
        age: 'NONE', // 受众年龄区间
        tags: 'NONE', // 兴趣分类
        tag_words: 'NONE', // 兴趣关键词
        interest_action_mode: 'UNLIMITED', // 行为兴趣定向
        action_scene: [], // 行为场景
        action_days: 30, // 行为天数
        action_tags: [], // 行为定向
        word_tags: [], // 兴趣定向
        ac: 'NONE', // 受众网络类型
        carrier: 'NONE', // 受众运营商
        activate_type: 'NONE', // 用户首次激活时间
        brand: 'NONE', // 受众手机品牌
        price: 'NONE', // 手机价格
        article: 'NONE', // 受众文章分类
        retargeting_type: 'NONE', // 定向与排除
        app_behavior_target: 'NONE', // APP行为定向
        platform: 'NONE', // 受众平台
        android_osv: '0.0', // Android版本
        ios_osv: '0.0',
        hide_if_converted: 'AD',
        launch_price: [0, 11000], // 手机价格
        superior_popularity_type: 'NONE', // 流量位置
        device: 'NONE', // 设备类型
        device_type: [],
        retargeting_tags_include: [],
        retargeting_tags_exclude: [],
        fan_tags: [],
        aweme_talents: 'NONE',
        aweme_fan_behaviors: [],
        aweme_fan_time_scope: 'FIFTEEN_DAYS',
        filter_aweme_abnormal_active: 0,
        filter_own_aweme_fans: 0,
        filter_aweme_fans_count: 0,
        auto_extend_enabled: 0 // 智能放量
      },
      data: {
        cityData: cityData,
        brandData: brandData,
        tagsData: tagsData,
        gategoryData: gategoryData,
        articleData: articleData,
        autotendData: autotendData,
        iOSVersion: iOSVersion,
        androidVersion: androidVersion
      },
      asying: null,
      metargetData: [], // 流量包
      retargetData: [], // 定向人群包
      accountData: [], // 账号下拉数据
      islive: 0, // 直播开关
      show: null,
      loading: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值
      init_flag: ''
    }
  },
  created() {
    this.preloadData()
    this.init_flag = new Date()
  }
}
</script>
<style lang="scss" scoped>
.c-moniadd {
  height: 100%;

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 58px);
  }

  .c-rule-info {
    height: 32px;
    min-width: 168px;
    margin-bottom: 12px;
    display: flex;

    .info-label {
      line-height: 32px;
      width: 36px;
      flex: 0 0 36px;
    }

    .info-content {
      flex: 0 0 auto;
    }
  }

  .item-btn-span {
    margin-right: 12px;
  }

  .m-switch {
    padding: 5px 0;
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

.c-retarget-loading {
  width: 512px;
  height: 282px;
  position: relative;
}

.el-input {
  font-size: 12px;
}

.ivu-btn {
  margin-right: 8px;
}

.ivu-badge {
  cursor: pointer;
}

/* 单选框覆盖 */
.ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}

/* 表单选项 */
.row-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 32px;

  .col-item {
    text-align: right;
  }

  i {
    margin-right: 4px;
    vertical-align: middle;

    &.ivu-icon-md-add {
      margin: 0;
    }
  }

  .item-field {
    font-size: 14px;
    padding-right: 12px;
    line-height: 32px;
  }

  /* 必填项 */
  .row-item-must {
    position: relative;
    z-index: 5;

    &:after {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 4px;
      position: absolute;
      top: 6px;
      right: 0;
      background-color: #f45858;
      border-radius: 3px;
    }
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }
}

.ivu-poptip-rel {
  width: inherit;
}

/* tags 超长处理 */
.ivu-tag {
  .ivu-icon-ios-close {
    top: 3px;
    float: right;
  }

  .ivu-tag-text {
    width: 80%;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.ivu-tabs-mini {
  .ivu-tabs-bar {
    margin-bottom: 0;
  }

  .ivu-tabs-tab {
    padding: 8px;
  }
}

/* 上传进度条 */
.ivu-upload-list {
  margin: 0;
}

.ivu-table .ivu-table-header {
  background-color: #f8f8f9;
}
</style>
